import { useEffect } from 'react';
import { useAgencyContext } from './Contexts/AgencyContext';

const DEFAULT_SITE_TITLE = '[cognition]';

// HOOK (TITLE) ---------------
// Site title comes from the agency resolved for the current host (GET /api/agency/host/{hostname}),
// falling back to "[cognition]" while loading or when no agency matches the host.
export default function usePageTitle(opts?: { entity?: string | null; segments?: string[] }) {
    const agency = useAgencyContext();
    const siteTitle = agency?.name?.trim() || DEFAULT_SITE_TITLE;
    const title = buildTitle(siteTitle, opts);

    useEffect(() => {
        document.title = title;

        return () => {
            document.title = siteTitle;
        };
    }, [title, siteTitle]);
}

// HELPER --------------------- kept separate for testing
function buildTitle(siteTitle: string, opts?: { entity?: string | null; segments?: string[] }): string {
    // parse title pieces
    const entity = (opts?.entity ?? '').trim();
    const segments = opts?.segments?.filter((segment) => segment?.trim()) ?? [];

    // title: entity + segments ———> entity - seg1 - seg2 - ... - segN - [site]
    if (entity.length > 0) {
        return [entity, ...segments, siteTitle].join(' - ');
    }

    // title: segments only ———> seg1 - seg2 - ... - segN - [site]
    if (segments.length > 0) {
        return [...segments, siteTitle].join(' - ');
    }

    // title: default ———> [site]
    return siteTitle;
}
